export default "__VITE_ASSET__B_HKG5vT__"